import ZipCodeQuoteItem from 'components/form/AddressSelector/Items/ZipCodeQuote/styled';

export default ZipCodeQuoteItem;
